module.exports = __webpack_public_path__ + "static/image3-725d325fe9a9fbbbc8295830674686e2.jpeg";